import { useEffect } from 'react';
import { useSelector } from '@xstate/store/react';
import { canvasSelectionStore } from '../stores/canvasSelectionStore';
import { useCanvasStores } from '../stores/CanvasContext';
import { usePanZoomEffects } from '../hooks/usePanZoom';
import { useCanvasBoxSelect } from '../hooks/useCanvasBoxSelect';
import { useCanvasMultiSelect } from '../hooks/useCanvasMultiSelect';
import { useConnectionDragEffect } from '../hooks/useConnectionDrag';
import { useEdgeRedockEffect } from '../hooks/useEdgeRedock';
import { useCanvasClipboard } from '../hooks/useCanvasClipboard';
import { useUndoRedoKeyboard } from '../hooks/useUndoRedo';

export function CanvasInteractionSetup() {
  const { store } = useCanvasStores();

  // Side-effect hooks (register global event listeners)
  usePanZoomEffects();
  useConnectionDragEffect();
  useEdgeRedockEffect();
  useCanvasBoxSelect();
  useCanvasMultiSelect();
  useCanvasClipboard();
  useUndoRedoKeyboard();

  // Subscribe to version counters — O(1) and stable during drag (versions don't change on position updates).
  const entityIdKey = useSelector(store, s =>
    `${s.context.nodesVersion},${s.context.connectorsVersion},${s.context.groupsVersion}`
  );

  // Prune selection when entity IDs change
  useEffect(() => {
    if (!entityIdKey) return;
    const ctx = store.getSnapshot().context;
    const raw = [
      ...Object.values(ctx.nodes),
      ...Object.values(ctx.connectors),
      ...Object.values(ctx.groups),
    ];
    const validIds = new Set<string>();
    for (const e of raw) validIds.add(e.id);
    canvasSelectionStore.send({ type: 'entity.prune', validIds });
  }, [entityIdKey, store]);

  return null;
}
